module.exports = __webpack_public_path__ + "img/success_logo.285bf1dd.png";